<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
          <!--
          <AppAddButton v-bind:permission="permission">
          <a @click.prevent="onAddButtonClick" class="btn btn-rounded btn-block-xs-only" style="background: rgb(38, 198, 218); color: #fff;">
            Add Bay
          </a>
          </AppAddButton>
          -->
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="onSearchChange" />
        
      </div>

      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterCarparkChange"
        v-bind:filterEmptyMessage="'No car park data available'" />

      <AppFilter 
        ref="zoneFilter" 
        filterKey="zoneID"
        v-show="zoneFilterVisible"
        v-on:filter-data-change="onFilterZoneChange"
        v-bind:filterEmptyMessage="'No car park zone data available'" />

      <AppFilter 
        ref="streetFilter" 
        filterKey="streetID"
        v-show="streetFilterVisible"
        v-on:filter-data-change="onFilterStreetChange"
        v-bind:filterEmptyMessage="'No car park street data available'" />
      
      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback ref="pageFeedback" />
      
      <AppModalForm 
        ref="pageModal" 
        v-bind:formParameter="PARAM" 
        v-bind:permission="permission"
        v-bind:modalShowDelete="false"
        v-on:modal-data-add="onModalAddDataClick"
        v-on:modal-data-edit="onModalEditDataClick"
        v-on:modal-data-delete="onModalDeleteDataClick" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: 'carparkID',
    text: 'Car Park',
    table_hide: true,
    form_select: [],
    form_chosen: true,
    form_add_input_attr: {
      disabled: true,
    },
    form_edit_hide: true,
    form_edit_input_attr: {
      disabled: true,
    },
    form_edit_validation: [],
  },
  {
    key: 'zoneID',
    text: 'Zone',
    table_hide: true,
    form_select: [],
    form_chosen: true,
    form_add_input_attr: {
      disabled: true,
    },
    form_edit_hide: true,
    form_edit_input_attr: {
      disabled: true,
    },
    form_edit_validation: [],
  },
  {
    key: 'streetID',
    text: 'Street',
    table_hide: true,
    form_select: [],
    form_chosen: true,
    form_add_input_attr: {
      disabled: true,
    },
    form_edit_hide: true,
    form_edit_input_attr: {
      disabled: true,
    },
    form_edit_validation: [],
  },
  {
    key: 'baySku',
    text: 'Bay Name',
    table_popup: true, 
    form_edit_input_attr: {
      disabled: true,
    }
  },
  {
    key: 'bayType',
    text: 'Bay Type',
    form_edit_input_attr: {
      disabled: true,
    }
  },
  {
    key: 'lat',
    text: 'Bay Latitude',
    form_input_attr: {
      'type': 'Number',
    },
  },
  {
    key: 'lon',
    text: 'Bay Longitude',
    form_input_attr: {
      'type': 'Number',
    },
    form_edit_validation: [],
  },
];

const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PageStreetBay",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Car Park', url: '/carpark' },
        { name: 'Zone', url: '/zone' },
        { name: 'Street', url: '/street' },
        { name: 'Bay' },
      ],

      PARAM,
      PARAM_MAP,

      zoneFilterVisible: false,
      streetFilterVisible: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.loadCarpark();
  },
  methods: {
    loadCarpark() {
      this.$refs['carparkFilter'].setFilterLoading('Loading car park data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], response.data);

          if(response.data && response.data.length > 0) {
            this.onFilterCarparkChange();
          }
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    loadZone() {
      this.$refs['pageTable'].setTableData(null);
      this.$refs['zoneFilter'].setFilterLoading('Loading zone data...');

      let url = helper.SERVER_URL + '/api2/zone';
      let carparkFilter = this.$refs['carparkFilter'].filterValue;
      if(carparkFilter) {
        url = helper.SERVER_URL + `/api2/carpark/${carparkFilter}/zone`;
      }

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          // this.$refs['zoneFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.zoneID);
          this.$refs['zoneFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Zone'}, response.data), this.$route.query.zoneID);
          helper.inputSelectSetOption(this.PARAM_MAP['zoneID'], response.data);

          if(response.data && response.data.length > 0) {
            this.onFilterZoneChange();
          }
        })
        .catch(error => {
          this.$refs['zoneFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', 'zone data'));
        });
    },
    loadStreet() {
      this.$refs['pageTable'].setTableData(null);
      this.$refs['streetFilter'].setFilterLoading('Loading street data...');

      let url = helper.SERVER_URL + '/api2/street/?1=1';
      let carparkFilter = this.$refs['carparkFilter'].filterValue;
      if(carparkFilter) {
        url += '&carparkID=' + carparkFilter;
        let zoneFilter = this.$refs['zoneFilter'].filterValue;
        if(zoneFilter) {
          url += '&zoneID=' + zoneFilter;
        }
      }

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          // this.$refs['streetFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.streetID);
          this.$refs['streetFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Street'}, response.data), this.$route.query.zoneID);
          helper.inputSelectSetOption(this.PARAM_MAP['streetID'], response.data);

          this.onFilterStreetChange();
        })
        .catch(error => {
          this.$refs['streetFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', 'street data'));
        });
    },
    loadData() {
      this.$refs['pageTable'].setTableLoading();

      // let url = this.getUrl(this.$refs['carparkFilter'].filterValue, this.$refs['zoneFilter'].filterValue, this.$refs['streetFilter'].filterValue);

      let url = helper.SERVER_URL + '/api2';
      url += '/bay/?1=1';
      let carparkFilter = this.$refs['carparkFilter'].filterValue;
      if(carparkFilter) {
        url += '&carparkID=' + carparkFilter;
        let zoneFilter = this.$refs['zoneFilter'].filterValue;
        if(zoneFilter) {
          url += '&zoneID=' + zoneFilter;
        }
        let streetFilter = this.$refs['streetFilter'].filterValue;
        if(streetFilter) {
          url += '&streetID=' + streetFilter;
        }
      }

      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);
          this.$refs['pageTable'].setTableData(response.data, this.$refs['pageTable'].getCurrentPage());
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', 'street bay data'));
        })
    },

    getUrl(carparkID, zoneID, streetID) {
      let url = helper.SERVER_URL + '/api2';
      url += '/bay/?1=1';
      if(carparkID) {
        url += '&carparkID=' + carparkID;
        if(zoneID) {
          url += '&zoneID=' + zoneID;
        }
        if(streetID) {
          url += '&streetID=' + streetID;
        }
      }

      return url;
    },

    onTablePageChange() {
      this.loadData();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },
    onFilterCarparkChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      if(this.$refs['carparkFilter'].filterValue) {
        this.zoneFilterVisible = true;
        this.streetFilterVisible = false;
        this.loadZone();
      } else {
        this.zoneFilterVisible = false;
        this.streetFilterVisible = false;
        this.loadData();
      }
    },
    onFilterZoneChange(dataIndex) {
      this.streetFilterVisible = true;
      this.loadStreet();
      // if(this.$refs['zoneFilter'].filterValue) {
      //   this.streetFilterVisible = true;
      //   this.loadStreet();
      // } else {
      //   this.streetFilterVisible = false;
      //   this.loadData();
      // }
    },
    onFilterStreetChange(dataIndex) {
      this.loadData();
    },

    onAddButtonClick() {
      this.$refs['pageFeedback'].setFeedbackMessage();
      
      let defaultData = this.$refs['pageModal'].$refs['modalForm'].getFormDefaultData();
      defaultData['carparkID'] = this.$refs['carparkFilter'].filterValue;
      defaultData['zoneID'] = this.$refs['zoneFilter'].filterValue;
      defaultData['streetID'] = this.$refs['streetFilter'].filterValue;

      this.$refs['pageModal'].setModalOpen(true, 'Add New Car Park Street Bay', defaultData);
    },
    onTableDataClick(tableData, tableDataIndex) {
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(false, 'Edit ' + tableData[tableDataIndex]['name'], tableData[tableDataIndex]);
    },

    onModalAddDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Adding ' + selectedData.name);
      
      this.$http
        .post(
          this.getUrl(selectedData.carparkID, selectedData.zoneID, selectedData.streetID),
          // helper.SERVER_URL + '/api2/bay/',
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['carparkFilter'].setFilterValue(selectedData.carparkID);
          this.$refs['zoneFilter'].setFilterValue(selectedData.zoneID);
          this.$refs['streetFilter'].setFilterValue(selectedData.streetID);
          this.upsertDataComplete('Successfully added ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'adding', 'data'));
        })
    },
    onModalEditDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Updating ' + selectedData.name);

      this.$http
        .put(
          // this.getUrl(selectedData.carparkID, selectedData.zoneID, selectedData.streetID) + selectedData.id,
          helper.SERVER_URL + '/api2/bay/' + selectedData.id,
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'updating', 'data'));
        })
    },
    onModalDeleteDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Deleting ' + selectedData.name);

      this.$http
        .delete(
          // this.getUrl(selectedData.carparkID) + selectedData.id,
          helper.SERVER_URL + '/api2/bay/' + selectedData.id,
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully delete ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'deleting', 'data'));
        })
    },
    upsertDataComplete(message) {
      this.$refs['pageModal'].setModalClose();
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/CarPark/PageStreetBay.vue